import { API_VERSIONS, asinzenAdminApi } from "client/api";

export const getRequestLogs = ({ email, filterMonth, limit, skip }: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .get(`/${API_VERSIONS}/admin/request-logs/get-list`, {
      params: { email, filter_by_month: filterMonth, limit, skip }
    })

export const truncateRequestLogs = (query: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/admin/request-logs/truncate`, { data: query })

export const deleteRequestLogs = ({ filterMonth, query }: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .delete(`/${API_VERSIONS}/admin/request-logs/delete`, { 
      params: { filter_by_month: filterMonth },
      data: query 
    })
